import type { GetAlumniParams } from './type';
export const alumniKeys = {
  all: ['alumni'] as const,
  list: (params: GetAlumniParams, isLeavingDateWithIn_A_Month?: boolean) => [...alumniKeys.all, 'list', params, isLeavingDateWithIn_A_Month] as const,
  count: () => [...alumniKeys.all, 'count'] as const,
  export: () => [...alumniKeys.all, 'export'] as const
} as const;